import React, { Component } from 'react';
import PropTypes from 'prop-types';

// External Component
import DayPicker, { DateUtils } from 'react-day-picker';
import styleFn from './DayCalendarStyles';

import { Flex } from 'rebass';

class DayCalendar extends Component {
  static propTypes = {
    onChange: PropTypes.func,
    disabledDates: PropTypes.array,
    blockedDates: PropTypes.array,
  };

  static defaultProps = {
    disabledDates: [],
    blockedDates: [],
  };

  constructor(props) {
    super(props);
    this.state = {
      selectedDays: [],
    };
  }

  componentWillMount() {
    const { blockedDates } = this.props;
    if (blockedDates != undefined) {
      this.setState({ selectedDays: blockedDates });
    }
  }

  componentWillReceiveProps(nextProps) {
    const { blockedDates } = nextProps;
    if (blockedDates != undefined) {
      this.setState({ selectedDays: blockedDates });
    }
  }

  isDaySelected = day => {
    const { selectedDays } = this.state;
    if (selectedDays.length > 0) {
      return selectedDays.some(selectedDay =>
        DateUtils.isSameDay(selectedDay, day),
      );
    }
  };

  handleDayClick = async (day, { disabled, selected }) => {
    if (disabled) {
      return;
    }
    const { blockedDates } = this.props;
    let selectedDays = blockedDates.slice();
    const { onChange } = this.props;
    if (selected) {
      const selectedIndex = selectedDays.findIndex(selectedDay =>
        DateUtils.isSameDay(selectedDay, day),
      );
      selectedDays.splice(selectedIndex, 1);
    } else {
      selectedDays.push(day);
    }
    this.setState({ selectedDays });
    await onChange(selectedDays);
  };

  render() {
    const { disabledDates } = this.props;
    let dateObj = new Date();

    return (
      <Flex>
        <DayPicker
          selectedDays={this.isDaySelected}
          onDayClick={this.handleDayClick}
          disabledDays={[DateUtils.isPastDay, ...disabledDates]}
          fromMonth={dateObj}
          toMonth={DateUtils.addMonths(dateObj, 11)}
          numberOfMonths={2}
        />
      </Flex>
    );
  }
}

export default styleFn(DayCalendar);



// WEBPACK FOOTER //
// ./src/components/DayCalendar/DayCalendar.js